import { ToasterType } from '@clickcease/cc-client-components-lib/dist/types/ToasterTypes'
import { useMutation } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { queryClient } from 'Lib/react-query'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useTranslation } from 'react-i18next'
import { useGetErrorText } from 'Utils/errorText'

/* Use for verify code that user received in email */

type Params = {
  userId: number
  code: string
}

export type VerifyInviteResponse = {
  data: {
    code: string
    userId: number
    accountId: number
  }
}

const verifyUrlCode = ({ userId, code }: Params) =>
  request<VerifyInviteResponse>({
    url: `users/${userId}/invite/accept`,
    method: 'PUT',
    data: { code },
    hideErrorToaster: true,
  })

export const useVerifyUrlCode = () => {
  const { t } = useTranslation('auth')
  const { showToaster } = useAppStore()
  const { getErrorText } = useGetErrorText()

  return useMutation(verifyUrlCode, {
    async onSettled(data, error) {
      const toaster: { type: ToasterType; text: string } =
        data instanceof Error
          ? { type: 'failure', text: getErrorText(error) || 'Something went wrong' }
          : { type: 'success', text: t('login.invitation_succeed') }

      if (!(data instanceof Error)) {
        await queryClient.invalidateQueries(['userAccounts']) // Reload user accounts
      }

      showToaster(toaster.text, toaster.type)
    },
  })
}
